import type { AxiosRequestConfig } from 'axios';
import { getOrCreateHeaders } from '@trialcard/shared';

import { Authentication } from './Authentication.js';

export class ApiKeyAuth extends Authentication {
    public apiKey: string = '';
    public constructor(private location: string, private paramName: string) {
        super();
    }
    public async applyToRequest(requestOptions: AxiosRequestConfig) {
        if (!requestOptions) {
            return Promise.reject(new Error('Axios request config can\'t be null or undefined.'));
        }

        if (this.location === 'query') {
            requestOptions.params = requestOptions.params ?? {};
            requestOptions.params[this.paramName] = this.apiKey;
        } else if (this.location === 'header') {
            getOrCreateHeaders(
                requestOptions
                )[this.paramName] = this.apiKey;
        }

        return Promise.resolve();
    }
}
